<template>
    <div>
        <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 12px;">
            <h2 class="mb-0">Relatório de Ordem de Serviço</h2>
            <v-btn outlined color="primary" @click="$router.push('/relatorios#comercial')">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar ao menu
            </v-btn>
        </div>
            <div class="d-flex w-100">
                <form class="w-100 flex-grow-1 d-flex mt-5 mb-5">
                    <v-row>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataInicio"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioOs"
                            />
                        </v-col>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataFim"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioOs"
                            />
                        </v-col>
                        
                        <v-col cols="2" sm="2" md="1">

                            <v-menu
                                :close-on-content-click="false"
                                location="end"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" large icon color="primary">
                                        <v-icon>mdi-filter</v-icon>
                                    </v-btn>
                                </template>

                                <v-card min-width="500">

                                    <v-card-title>
                                        Filtro
                                    </v-card-title>

                                    <v-card-text>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="Código" 
                                            solo 
                                            v-model="filter.codigo"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="JOB" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.job"
                                        >
                                        </v-text-field>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn variant="text">
                                            Cancel
                                        </v-btn>
                                        <v-btn color="primary" variant="text" @click="getRelatorioOs">
                                            Filtrar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                            </v-menu>
                        </v-col>

                    </v-row>

                </form>
                
                <div class="text-center mt-5 ml-5">
                    <v-menu>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                v-on="on" 
                                large
                            >
                                Gerar Relatorio
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, index) in actions"
                                :key="index"
                                :value="index"
                                @click="item.handle"
                                class="cursor-pointer"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </v-menu>
                </div>

            </div>
        
        <relatorio-table-view
            :dados-tabela="dadosTabela"
        />

        <RelatorioListPreview 
            :isOpen="openRelatorioPreview"
            :dadosTabela="dadosTabela"
            @cancel="openRelatorioPreview = false"
        />

    </div>
</template>

<script>
import Vue from 'vue';
import * as XLSX from 'xlsx'
import moment from 'moment'
import RelatorioListPreview from './RelatorioListPreview.vue';
import RelatorioTableView from './RelatorioTableView.vue';

export default {
    name: 'RelatorioOsView',
    components: {
        RelatorioListPreview,
        RelatorioTableView
    },
    data(){
        return {
            openRelatorioPreview: false,
            dadosTabela: [],
            filter: {
                dataInicio: null,
                dataFim: null,
                codigo: '',
                job: ''
            },
            actions: [
                {
                    title: "Gerar XLS",
                    handle: () => {
                        this.exportToExcel()
                    }
                },
                {
                    title: "Gerar PDF",
                    handle: () => {
                        this.openRelatorioPreview = true
                    }
                }
            ]
        }
    },
    methods: {
        async getRelatorioOs() {
            if(this.filter.dataInicio != null && this.filter.dataFim != null){
                const response = await Vue.prototype.$http.post('/View/run', {
                        params: [
                            { dataType: "string", name: "dataInicio", value: moment(this.filter.dataInicio).toISOString() },
                            { dataType: "string", name: "dataFim", value: moment(this.filter.dataFim).toISOString() },
                            { dataType: "string", name: "codigo", value: this.filter.codigo },
                            { dataType: "string", name: "job", value: this.filter.job }
                        ],
                        viewId: "a3da9222-d1c8-480e-85e2-1e25763d0922",
                        page: 1,
                        limit: 3000000

                })
                this.dadosTabela = response.data.data.data
            }
        },

        exportToExcel() {
            const dataRelatorio = this.dadosTabela.map((dado) => {
                return {
                    'CÓD.': dado?.codigo || '',
                    'Orçamento': dado?.job?.[0]?.solicitacaoDeOrcamentoCodigo || '',
                    'Cliente': dado?.job?.[0]?.clienteNome || '',
                    'Projeto': dado?.job?.[0]?.code || '',
                    'Contato': dado.job.contatoComercial.celular,
                    'Fone': dado.job.contatoComercial.telefone,
                    'Dt.Solicitação': dado?.dataSolicitacao
                        ? new Date(dado.dataSolicitacao).toLocaleDateString('pt-BR')
                        : '',
                    'Prazo': new Date(dado.dataEncerramentoPrevista).toLocaleDateString(),
                    'Vendedor': dado.job.cliente.verndedorNome || '',
                }
            })

            const ws = XLSX.utils.json_to_sheet(dataRelatorio)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Relatório')

            XLSX.writeFile(wb, 'relatorio-ordem-servico.xlsx')
        }
    }
}
</script>

<style scoped>

</style>